<template>
  <div class="sharing-tab">
    <div class="row">
      <div class="col-10 offset-1">
        <h4 class="mb-3">Sharing</h4>

        <p class="rs-text text-white">Use the link below to share your gear setup with others</p>

        <TextSetting v-if="!shared" :text="'Share Setup'" :icon="'/static/images/icons/clan_chat.png'"
                     @update="share" v-b-tooltip.hover.bottom
                     :title="'Gear setups can be shared with others to load in the exact gear loadout you currently\n'+
'          have setup.'"></TextSetting>

        <div class="sharing-code" v-if="shared">
          <input class="form-control text-center" readonly :value="shareUrl">
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-10 offset-1">
        <h5>Gear Presets</h5>

        <p class="rs-text text-white">Store commonly used gear setups and switch between them.</p>

        <select v-model="selectedPreset" class="form-control form-control">
          <option disabled value="0">Select Preset...</option>
          <option value="new">New Preset</option>
          <option v-for="(preset,idx) in presets" :key="idx" :value="preset.id">{{preset.name}}</option>
        </select>

        <input v-model="newPresetName" v-show="selectedPreset === 'new'" class="form-control form-control mt-3"
               placeholder="Preset Name">
      </div>
    </div>


    <div class="row mt-4">
      <!--      <div class="col-3 offset-1">-->
      <!--        <Setting :description="'Clone to other set'" :icon="'/static/images/icons/equipment_swap_large.png'"-->
      <!--                 :setting="false"-->
      <!--                 @update="$emit('clone')"></Setting>-->
      <!--        <h5 class="mt-2">Clone Setup</h5>-->
      <!--      </div>-->
      <div class="col-5 offset-1">
        <Setting :description="'Save Preset'" :icon="'/static/images/icons/equipment_save_large.png'" :setting="false"
                 @update="savePreset"></Setting>
        <h5 class="mt-2">Save Preset</h5>
      </div>
      <div class="col-5">
        <Setting :description="'Load Preset'" :icon="'/static/images/icons/equipment_load_large.png'" :setting="false"
                 @update="loadPreset"></Setting>
        <h5 class="mt-2">Load Preset</h5>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-10 offset-1">
        <TextSetting :text="'Clone Set'" :icon="'/static/images/icons/equipment_swap_large.png'"
                     :setting="false"
                     @update="$emit('clone')"></TextSetting>
      </div>
    </div>
  </div>
</template>

<script>
  import Setting from "./settings/Setting";
  import TextSetting from "./settings/TextSetting";

  export default {
    name: "SharingTab",
    components: {TextSetting, Setting},
    props: {
      shared: {
        type: Boolean,
        default() {
          return false
        }
      },
      setup: {
        type: Object,
      }
    },
    data() {
      return {
        shareCode: '',
        newPresetName: '',
        selectedPreset: '0',
        presets: [],
      }
    },
    computed: {
      shareCodeSplit: function () {
        if (this.shareCode === '') {
          return '';
        }

        return this.shareCode.match(/.{1,4}/g).join('-')
      },
      shareUrl: function () {
        return `${window.location.href}?s=${this.shareCode}`
      }
    },
    watch: {
      setup: function (newVal, oldVal) {
        console.log("Setup Change");
        this.shareCode = '';
      },
    },
    methods: {
      share: function () {
        const uri = `${process.env.API_ADDR}/share`;

        this.$http.post(uri, {
          cid: 'gear-setup',
          data: JSON.stringify(this.setup),
        }).then((resp) => {
          if (resp.data === "" || resp.status !== 200) {
            return;
          }

          console.log('post share', resp.data);
          this.shareCode = resp.data.uuid;
          this.$emit('shared')
        })
      },

      savePreset: function () {
        if (this.selectedPreset === '0' && this.newPresetName === '') {
          this.$toasted.error('Missing preset name', {duration: 2000});
          return;
        }

        let existingPreset = this.presetFromId(this.selectedPreset);
        let id = Math.random().toString(36).slice(2);
        let name = this.newPresetName;

        console.log(`existingPreset`, existingPreset);
        if (existingPreset !== null) {
          id = existingPreset.id;
          name = existingPreset.name;
        }

        console.log(`savePreset`, id);
        localStorage.setItem(`osrs:preset:${id}`, JSON.stringify(this.setup));

        if (existingPreset == null)
          this.updatePresetList(name, id);

        this.newPresetName = '';
        this.selectedPreset = id;
        this.$toasted.success('Preset saved', {duration: 2000});
      },

      loadPreset: function () {
        let preset = localStorage.getItem(`osrs:preset:${this.selectedPreset}`);
        if (preset === null) {
          this.$toasted.error('Error loading preset', {duration: 2000});
          return;
        }

        this.$toasted.success('Preset loaded', {duration: 2000});
        this.$emit('load', JSON.parse(preset))
      },

      updatePresetList: function (name, id) {
        console.log(`updatePresetList`, [name, id]);

        let presetList = localStorage.getItem('osrs:list:preset');
        if (presetList !== null) {
          presetList = JSON.parse(presetList);
        } else {
          presetList = [];
        }

        presetList.push({name: name, id: id});
        this.presets = presetList;

        localStorage.setItem('osrs:list:preset', JSON.stringify(presetList))
      },

      loadPresetList: function () {
        let presetList = localStorage.getItem('osrs:list:preset');
        if (presetList === null) {
          return
        }
        this.presets = JSON.parse(presetList)
      },

      presetFromId: function (id) {
        for (let k in this.presets) {
          if (this.presets[k].id === id)
            return this.presets[k]
        }

        return null;
      }
    },
    mounted() {
      this.loadPresetList();
    }
  }
</script>

<style scoped>
.sharing-info {
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/tabs/SharingTab.vue